const Theme = {
  card_background_color: 'white',
  body_background_color: '#7cb342',

  token_url: 'campervan.png',
  number_hidden: true,

  text_font: 'Calibri',
  text_color: 'black',
  title_font: 'Calibri',
  title_weight: 400,
  subtitle_font: 'Calibri',

  logo_image_url: 'campervan.png',
  logo_height:120,

  button_color:'#7cb342',
  button_radius:10,
  button_border_width:2,
}

export default Theme
